/**
 * Builds a safely-encoded redirect target (path + query) to append as a single
 * `?redir=<value>` param when sending an unauthenticated user to the login
 * page, so the login flow can return them to exactly where they were headed
 * (e.g. an email-campaign deep link with UTM/campaign params).
 *
 * The whole target is URL-encoded so it survives as one query value. The
 * previous approach left the path, `?` and `=` unencoded, producing an invalid
 * double-`?` URL that dropped params on deep links after login.
 */
function toRedirString(path = '', queryParams: Record<string, any> = {}) {
  const search = Object.keys(queryParams)
    .filter(
      (key) => key !== 'redir' && key?.length && `${queryParams[key]}`.length
    )
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&');

  let target = '';
  if (path.length) {
    target = path;
  }
  if (search.length) {
    target = `${target}?${search}`;
  }

  return target ? encodeURIComponent(target) : '';
}

export default toRedirString;
